export const environment = {
  production: true,
  assetsUrl: 'https://assets.julian-scholz.dev',
};
